import { Injectable } from '@angular/core';
import { TodoItemNode } from '../../model/notes.model';
import { LocalDatabaseService } from '../firestore/local-database.service';

@Injectable({
  providedIn: 'root'
})
export class NotesFilterService {

  private localDb: LocalDatabaseService;

  constructor() { }

  setLocalDb(localDb: LocalDatabaseService) {
    this.localDb = localDb;
  }

  /*******************************************************/
  // FILTER FUNCTIONS
  /*******************************************************/

  filterOutNotebooksByName (filterValue:string) {

    //#1 Primeiro move todos do filterOut para o principal
    this.cleanFilter();
    let mainArray: TodoItemNode[] = this.localDb.data;

    //   node.parentRef.children.splice(node.parentRef.children.findIndex(itemNode => {return itemNode == node}), 1);

    if (filterValue && (filterValue.length > 0)) {
      //#2 Faz a filtragem - se não dar match move para o filterOut
      mainArray.forEach((node) => {

        //console.log("filter value = " + filterValue);

        let string1 = filterValue.toLocaleLowerCase();
        let string2 = node.item ? node.item.toLocaleLowerCase() : '';

        if (!string2.includes(string1)) {
          this.localDb.filterOutNotebooks.push(node);
          //console.log("filtering OUT = " + node.item);
        }
      });

       //remove do main
      this.localDb.filterOutNotebooks.forEach(node => {
        mainArray.splice(mainArray.findIndex(itemNode => {return itemNode == node}), 1);
      })

    }

    this.localDb.dataChange.next(mainArray);

    // melhor manter um array dos filtersOut separado
    // dai move do array principal para o filterOut ou do filterOut para o principal caso inclua

    //#1 Primeiro move todos do filterOut para o principal
    //#2 Faz a filtragem - se não dar match move para o filterOut
    //#3 notifica mudança

    //* quando tiver em outras telas sempre chama essa funcao com null ou vazi como parâmetro
  }

  filterOutNotebooksById(id: string) {
    //#1 Primeiro move todos do filterOut para o principal
    this.cleanFilter();
    let mainArray: TodoItemNode[] = this.localDb.data;
    //   node.parentRef.children.splice(node.parentRef.children.findIndex(itemNode => {return itemNode == node}), 1);

    if (id && (id.length > 0)) {
      //#2 Faz a filtragem - se não dar match move para o filterOut
      mainArray.forEach((node) => {

        //console.log("filter value = " + filterValue);

        if (id != node.id) {
          this.localDb.filterOutNotebooks.push(node);
          //console.log("filtering OUT = " + node.item);
        }
      });

      //remove do main
      this.localDb.filterOutNotebooks.forEach(node => {
        mainArray.splice(mainArray.findIndex(itemNode => { return itemNode == node }), 1);
      })

    }

    this.localDb.dataChange.next(mainArray);
  }

  cleanFilter() {
    let mainArray: TodoItemNode[] = this.localDb.data;
    mainArray = mainArray.concat(this.localDb.filterOutNotebooks);
    this.localDb.filterOutNotebooks = new Array<TodoItemNode>();

    this.localDb.dataChange.next(mainArray);
  }


}
